import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const PaginationItem = props => {
  const { active, className, theme, disabled, tag: Tag, ...attributes } = props

  const classes = classNames(className, theme['page-item'], {
    [theme['active']]: active,
    [theme['disabled']]: disabled,
  })

  return <Tag {...attributes} className={classes} />
}

PaginationItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.object,
  disabled: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
}

PaginationItem.defaultProps = {
  tag: 'li',
}

export default PaginationItem



// WEBPACK FOOTER //
// ./ui/Pagination/PaginationItem.js